import { Autocomplete, TextField } from '@mui/material';
import { useFormikContext } from 'formik';
import { capitalize, find } from 'lodash';
import { useMemo } from 'react';

// Components
import PaperSelect from 'src/components/common/PaperSelect';

// Utilities
import { useQueryPeopleIndustry } from 'src/services/queries';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';

interface IProps {
  label?: string;
  id: string;
  countryCode: string[];
  required?: boolean;
  error?: boolean;
  disabled?: boolean;
}

const FormItemIndustryPeople = ({ label, id, countryCode, required, error, disabled }: IProps) => {
  const { values, handleBlur, setFieldValue } = useFormikContext<ExpectedAny>();
  const { data, isFetching } = useQueryPeopleIndustry(countryCode);
  const { data: listIndustry = [] } = data;

  const getIndustryByDesc = (industryDesc: string) => {
    if (!industryDesc) {
      return null;
    }
    const product = find(listIndustry, (o) => o.industry_desc === industryDesc);

    if (!product) {
      setFieldValue(id, '');
      return null;
    }

    return product;
  };

  const industry = useMemo(() => {
    return getIndustryByDesc(values[id]);
  }, [values[id], data.data]);

  return (
    <Autocomplete
      id={id}
      value={industry}
      loading={isFetching}
      onBlur={handleBlur}
      onChange={(_, value) => {
        setFieldValue(id, value?.industry_desc);
      }}
      autoComplete
      disabled={disabled}
      fullWidth
      size="small"
      autoHighlight
      options={getArrayDefault(listIndustry)}
      PaperComponent={PaperSelect}
      getOptionLabel={(option) => capitalize(option?.industry_desc || '')}
      renderInput={(params) => (
        <TextField {...params} error={error} required={required} label={<span>{label ?? 'Industry'}</span>} />
      )}
    />
  );
};

export default FormItemIndustryPeople;
